<template>
  <div class="soar-container flex flex-col gap-y-4">
    <h1 class="text-xl md:text-2xl text-primary font-medium border-b border-brand-gray-300">
      {{ $t('changeUsername') }}
    </h1>

    <div class="w-full flex justify-center">
      <div class="rounded-md border border-brand-gray-300 p-2 w-full md:w-1/3">
        <Form
          class="flex flex-col gap-3"
          v-slot="{ setFieldValue, resetForm }"
          @submit="(values) => onSubmit(values, resetForm)"
        >
          <div class="flex gap-4 flex-col justify-center">
            <div class="p-2 pb-1 rounded-md border-sky-500 bg-sky-400 text-white text-xs">
              {{ $t('changeUserNameHint') }}
            </div>
            <Field
              :rules="requiredRule"
              validate-on-input
              validate-on-change
              validate-on-blur
              name="password"
              v-slot="{ field, errors: errs }"
            >
              <TextInput
                :field="field"
                :errors="errs"
                :label="$t('Password')"
                input-type="password"
                label-class="w-full"
                class="w-full"
                direction="flex-col"
              />
            </Field>

            <Field
              :rules="validEmail"
              validate-on-input
              validate-on-change
              validate-on-blur
              name="userName"
              v-slot="{ field, errors: errs }"
            >
              <TextInput
                :field="field"
                :errors="errs"
                :label="$t('newEmail')"
                label-class="w-full"
                class="w-full"
                direction="flex-col"
              />
            </Field>
          </div>
          <GRecaptcha
            ref="gRecaptchaRef"
            class="flex justify-center"
            @successCallback="(args) => setFieldValue('recaptchaResponse', args)"
          ></GRecaptcha>
          <button
            class="text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
          >
            <div class="p-2 bg-primary rounded-s-md">
              <faDiskette class="w-4 fill-white"></faDiskette>
            </div>
            <span class="w-full text-center">
              {{ $t('Confirm') }}
            </span>
            <div class="p-0.5"></div>
          </button>
        </Form>
      </div>
    </div>
  </div>
</template>

<script setup>
import faDiskette from '@/assets/icons/faDiskette.svg?component'
import GRecaptcha from '@/components/GRecaptcha/index.vue'
import TextInput from '@/components/SimpleForm/TextInput.vue'
import { isValidEmail } from '@/composables/useRuleHandler.js'
import authService from '@/services/auth'
import { notify } from 'notiwind'
import { Field, Form } from 'vee-validate'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const router = useRouter()
const i18n = useI18n()

function requiredRule(value) {
  if (!value || !`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  return true
}

function validEmail(value) {
  return isValidEmail(value) || 'INVALID_EMAIL'
}

const onSubmit = async (values, resetForm) => {
  if (!values.recaptchaResponse) {
    notify(
      {
        group: 'error',
        title: i18n.t('captchaNotProcessed')
      },
      6000
    )
    return
  }

  await authService.changeUsername(values)

  resetForm()
  notify(
    {
      group: 'success',
      title: i18n.t('changeUserSuccess')
    },
    6000
  )

  router.push('/')
}
</script>

<style lang="scss" scoped></style>
